import axios from 'axios'
import endpoints from '../../endpoints'

const API_URL = process.env.REACT_APP_API_URL

export async function fetchGuardiansList() {
  try {
    const response = await axios.get(API_URL + endpoints.guardian.list)
    return response.data
  } catch (error) {
    throw error
  }
}

export async function getGuardianById(id: string | number) {
  try {
    const response = await axios.get(API_URL + endpoints.guardian.getById + id)
    return response.data
  } catch (error) {
    throw error
  }
}

export async function fetchLinkedStudentsList(guardianId: string | number) {
  try {
    const response = await axios.get(API_URL + endpoints.guardian.linkedStudents + guardianId)
    return response.data
  } catch (error) {
    throw error
  }
}

export async function linkStudentToGuardian(body: {
  student_id: string | number
  parent_id: string | number
  relation: string
}) {
  try {
    const response = await axios.post(API_URL + endpoints.guardian.linkToStudent, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function unlinkStudentFromGuardian(body: {
  student_id: string | number
  parent_id: string | number
}) {
  try {
    const response = await axios.post(API_URL + endpoints.guardian.unlinkFromStudent, body)
    return response.data
  } catch (error) {
    throw error
  }
}

export async function createGuardian(body: any) {
  try {
    const response = await axios.post(API_URL + endpoints.guardian.create, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function updateGuardian(body: any) {
  try {
    const response = await axios.post(API_URL + endpoints.guardian.update, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function deleteGuardian(guardianId: string | number) {
  try {
    const response = await axios.get(API_URL + endpoints.guardian.delete + guardianId)   
    return response.data
  } catch (error) {
    console.log(error)
    throw error
  }
}
export async function setPrimaryGuardian(payload: any) {
  try {
    const response = await axios.post(API_URL + endpoints.guardian.setPrimary, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
